import _classCallCheck from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @module ol/ImageBase
 */
import EventTarget from './events/Target.js';
import EventType from './events/EventType.js';
import { abstract } from './util.js';
/**
 * @abstract
 */

var ImageBase =
/*#__PURE__*/
function (_EventTarget) {
  _inherits(ImageBase, _EventTarget);

  /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|undefined} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default} state State.
   */
  function ImageBase(extent, resolution, pixelRatio, state) {
    var _this;

    _classCallCheck(this, ImageBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageBase).call(this));
    /**
     * @protected
     * @type {import("./extent.js").Extent}
     */

    _this.extent = extent;
    /**
     * @private
     * @type {number}
     */

    _this.pixelRatio_ = pixelRatio;
    /**
     * @protected
     * @type {number|undefined}
     */

    _this.resolution = resolution;
    /**
     * @protected
     * @type {import("./ImageState.js").default}
     */

    _this.state = state;
    return _this;
  }
  /**
   * @protected
   */


  _createClass(ImageBase, [{
    key: "changed",
    value: function changed() {
      this.dispatchEvent(EventType.CHANGE);
    }
    /**
     * @return {import("./extent.js").Extent} Extent.
     */

  }, {
    key: "getExtent",
    value: function getExtent() {
      return this.extent;
    }
    /**
     * @abstract
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     */

  }, {
    key: "getImage",
    value: function getImage() {
      return abstract();
    }
    /**
     * @return {number} PixelRatio.
     */

  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      return this.pixelRatio_;
    }
    /**
     * @return {number} Resolution.
     */

  }, {
    key: "getResolution",
    value: function getResolution() {
      return (
        /** @type {number} */
        this.resolution
      );
    }
    /**
     * @return {import("./ImageState.js").default} State.
     */

  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
    /**
     * Load not yet loaded URI.
     * @abstract
     */

  }, {
    key: "load",
    value: function load() {
      abstract();
    }
  }]);

  return ImageBase;
}(EventTarget);

export default ImageBase;